import { render, staticRenderFns } from "./CPToolbarMenu.vue?vue&type=template&id=7024c44e&scoped=true"
import script from "./CPToolbarMenu.vue?vue&type=script&lang=js"
export * from "./CPToolbarMenu.vue?vue&type=script&lang=js"
import style0 from "./CPToolbarMenu.vue?vue&type=style&index=0&id=7024c44e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7024c44e",
  null
  
)

export default component.exports